<form [formGroup]="formStopAlert" (ngSubmit)="SaveFormStopAlert()">
<div class="container">
    <div class="close-btn-fill-area" mat-dialog-close>
        <span class="close-btn">
        </span>

    </div>

    <div class="divToggle">
        <img src="/assets/images/pauseAlert/Group 27397.png" width="50"   alt="Imagen">
    </div>
    <div class="divTitles">
        <p class="title">{{ "LABEL_PAUSE_ALERT" | translate}}</p>
        <p class="subtitle">{{ "LABEL_SURE_ALERT" | translate}}</p>
        <p class="subsubtitle">{{ "LABEL_THIS_ACTION_ALERT" | translate}}</p>
        <p class="titleHeader">{{ "LABEL_LENGTH_ALERT" | translate}}</p>

        <div class="radio-group">

            <mat-radio-group formControlName="options">
                <div>
                    <mat-radio-button value="1">{{ "LABEL_ALL_DAYS_ALERT" | translate}}</mat-radio-button>
                </div>
                
                <mat-radio-button value="2">{{ "LABEL_TIME" | translate}}</mat-radio-button>
                
                <div  [formGroup]="filters">
                 <div>
                    <p class="textSelect">
                        {{"incidentType" | translate}}
                     </p>
                 </div>   
                <div class="select">
                    <mat-form-field color="white" appearance="outline">
                        <mat-select #selIncidentType  formControlName="incidentType"  multiple>
          
                            <mat-select-trigger>
                                <span *ngIf="((filters.get('incidentType').value?.length || 0) == 1)">
                                  {{ filters.get('incidentType').value[0]?.name || "SELECT_ALL" | translate }}
                                </span>
                                <span *ngIf="((filters.get('incidentType').value?.length || 0) > 1 && filters.get('incidentType').value[0]?.name !== undefined)">
                                  {{ filters.get('incidentType').value[0]?.name || "SELECT_ALL" | translate }}
                                </span>
              
                                <span *ngIf="((filters.get('incidentType').value?.length || 0) > 1 && filters.get('incidentType').value[0]?.name == undefined)">
                                  {{ filters.get('incidentType').value[1]?.name || "SELECT_ALL" | translate }}
                                </span>
              
                                <span *ngIf="((filters.get('incidentType').value?.length || 0) > 1)">
                                  (+{{(filters.get('incidentType').value?.length || 0) - 1}} {{filters.get('incidentType')?.length === 2 ? '...' : '...'}})
                                </span>
                              </mat-select-trigger>
          
                            <mat-option (click)="toggleAllSelection(selIncidentType)" [value]="0">{{ "SELECT_ALL" | translate }}</mat-option>
                            <mat-option *ngFor="let option of arrayIncidentsTypes" [value]="option">{{option.name}}</mat-option>
                        </mat-select>
                      </mat-form-field>
          
                </div>
            </div>
          
                



                
             <div>
<mat-form-field  appearance="fill">
    <mat-label>{{ "HOURS" | translate}}</mat-label>
    <mat-select formControlName="time">
      <mat-option *ngFor="let number of numbers" [value]="number">
        {{ number }}
      </mat-option>
    </mat-select>
  </mat-form-field>
</div>


            </mat-radio-group>
            
        </div>
    </div>

          
<table class="full-width-table">
    <tr>
    <td style="text-align: center;">
        
        <button   mat-stroked-button (click)="close()">
          
            {{ 'DIALOG_BACK_CANCEL' | translate}}
            
            
        </button>
    </td>
    <td style="text-align: center;">
        <button mat-raised-button color="primary">
          
          {{ 'SAVE' | translate}}
          
        </button>

      
    </td>
  </tr>
</table>



</div>

</form>